import { Loader2 } from "lucide-react";
import { useCheckout } from "../hooks/useCheckout";

export const CardCheckout = ({ items, testid = "card-checkout-button" }) => {
  const { buyItems, loading } = useCheckout();

  return (
    <div>
      <div className="flex items-center gap-4 my-4">
        <span className="flex-1 h-px bg-white/10" />
        <span className="text-[10px] uppercase tracking-[0.25em] text-ash/60">or</span>
        <span className="flex-1 h-px bg-white/10" />
      </div>
      <button
        onClick={() => buyItems(items)}
        disabled={loading}
        className="group relative w-full rounded-full border border-gold/60 py-4 text-xs uppercase tracking-[0.25em] text-gold overflow-hidden transition-colors duration-500 hover:text-ink disabled:opacity-60"
        data-testid={testid}
      >
        <span className="absolute inset-0 bg-gold translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" />
        {loading ? (
          <Loader2 className="relative h-4 w-4 animate-spin mx-auto" />
        ) : (
          <span className="relative">Pay by Card</span>
        )}
      </button>
    </div>
  );
};
